export default __webpack_public_path__ + "static/media/Illustration_HSC_Engineering_workflow_001_1250.d58060dd.png";